import {connect} from 'react-redux';

const mapDispatchToProps = () => ({
  getFBReviews: async () => {
    if (window.FB) {
      const url = 'https://graph.facebook.com/v7.0/gaelleboudiersinger?fields=ratings%7Bopen_graph_story%7D&access_token=EAADgGSShZA50BAJufIjCEHYpcyQw26bG2OWF6mlwJEYdQmmW4dCwVHGD3nikZAmRcwqLp41t9bvZC3ZCXZB6akeDTne7TV3JP1pjkRrRQRvveRnWEcEGRaCvyQ9M1DEjbnynkttbMCkUWkSPKlBE9evmaVEenkUMRT2OMMmEGxgsMCwKNDVvlRhpP0qWAIvENUZB1E0DvrYwZDZD';
      const reviews = await fetch(url)
        .then((resp) => resp.json())
        .then((ratings) => ratings);

      return reviews;
      // window.FB.api(
      //   'v7.0/gaelleboudiersinger/ratings',
      //   function (response) {
      //     console.log(response);
      //     if (response && !response.error) {
      //       /* handle the result */
      //     }
      //   }
      // );
    }
    return [];
  },
});

export default (component) => connect(null, mapDispatchToProps)(component);



// WEBPACK FOOTER //
// ./src/organisms/MainReview/MainReviewController.js